// ANGEL FLIGHT — mission registry. The campaign extends here.

import type { MissionDef } from '../core/types';
import { overpass } from './m1-the-overpass';
import { nightRaid } from './m2-night-raid';
import { treeline } from './m3-the-treeline';
import { whiteout } from './m4-whiteout';
import { endless } from './endless';

export const MISSIONS: readonly MissionDef[] = [overpass, nightRaid, treeline, whiteout] as const;

// Re-export the endless mode so the menu + App can deploy it. It is deliberately
// OUTSIDE `MISSIONS` (the campaign): it never appears in the campaign list, never
// gates, and missionIndexOf returns -1 so it can't advance mission progress.
export { endless, ENDLESS_ID } from './endless';

/** Every PLAYABLE mode (campaign + endless) — the lookup getMission resolves. */
const PLAYABLE: readonly MissionDef[] = [...MISSIONS, endless] as const;

export function getMission(id: string): MissionDef {
  return PLAYABLE.find((m) => m.id === id) ?? overpass;
}

/** Campaign index of a mission id, or -1 if unknown. Progression math
 *  (missionProgress = max(progress, index + 1)) keys off this so REPLAYING an
 *  already-cleared mission can never advance the campaign. */
export function missionIndexOf(id: string): number {
  return MISSIONS.findIndex((m) => m.id === id);
}

export function missionAtProgress(progress: number): MissionDef {
  const i = Math.max(0, Math.min(MISSIONS.length - 1, progress));
  return MISSIONS[i] ?? overpass;
}
